import { render, staticRenderFns } from "./arrowDown.vue?vue&type=template&id=2aff7b0c&"
import script from "./arrowDown.vue?vue&type=script&lang=ts&"
export * from "./arrowDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports